import { createAction } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const setBalances = createAction<AppState['balances']>(
  'user/setBalances',
)

export const setBalancesReducer = (
  state: AppState['balances'],
  action: ReturnType<typeof setBalances>,
): void => {
  state.client = action.payload.client
  state.shop = action.payload.shop
  state.isLoading = action.payload.isLoading
}
